<!--
 * @Description: 上传文件 拖拽
 * @Author: cxh
 * @Date: 2022-05-24 16:25:08
 * @LastEditTime: 2023-04-24 11:21:16
 * @LastEditors: cxh
-->
<template>
  <div>
    <a-upload-dragger
      :accept="accept"
      :file-list="fileList"
      :custom-request="customRequest"
      :before-upload="beforeUpload"
      @remove="remove"
    >
      <div>
        <img class="world-time-item__img" :src="excel" style="height: 36px; width: 36px" />
        <p>{{ t('tips.5FMCF8') }}</p>
        <div class="c999">{{ t('tips.or') }}</div>
        <a-button type="primary">
          {{ uploadText || t('btn.selectFile') }}
        </a-button>
      </div>
      <template #itemRender="{ file }">
        <!---温馨提示-->
        <div v-if="file.type === 'tips'" class="tips">
          <p>
            1.{{ t('tips.templeDown') }} :<a-button style="padding: 0" type="link" primary @click="exportTemple">{{
              t('btn.importTemplate')
            }}</a-button>
          </p>
          <p v-if="accept">2.{{ t('tips.templeDownForm', { fileType: accept }) }}</p>
        </div>
      </template>
    </a-upload-dragger>
    <div v-if="uploadFile" class="upload-content">
      <div class="upload-progress">
        <a-progress :percent="progress" stroke-color="#3FAC46" status="active" :stroke-width="30" />
        <p class="upload-progress-percent" :style="{ left: progress + '%' }">{{ progress }}%</p>
      </div>
      <p>{{ uploadFile.name }}</p>
    </div>
  </div>
</template>
<script lang="ts" setup name="uploadFile">
import request from '@/utils/request'
import { ref } from 'vue'
import { Modal, Form } from 'ant-design-vue'
import excel from '@/assets/uploadFile/excel.svg'
import { DcMessage } from '@dc-platform/dc-components'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
type fileTypes = {
  url: string
  name: string
}
type FileListTypes = {
  name: string
  uid?: string
  status?: string
  url: string
  response?: string
  type?: string
}
type UploadFileTypes = {
  name: string
  uid: string
  status: string
}
const props = defineProps({
  action: {
    type: String, // 接口地址
    default: ''
  },
  uploadText: {
    type: String
  },
  disabled: {
    type: Boolean,
    default: false
  },
  templateUrl: {
    type: String,
    default: ''
  },
  accept: {
    type: String,
    default: '.excel,.xls,.xlsx'
  },
  fileSize: {
    type: Number,
    default: 2 // 2M
  }
})
const uploadFile = ref<UploadFileTypes>()
const formItemContext = Form.useInjectFormItemContext()
const progress = ref<number>(10)
const fileList = ref<FileListTypes[]>([{ type: 'tips', name: 'tips', url: 'tips' }])
const resultFileList = ref<fileTypes[]>([])
const emit = defineEmits(['success', 'uploadSuccess'])
// const fileFormatter = (data: any) => {
//   const file: {
//     name: string
//     uid: string
//     status: string
//     url: string
//     response: string
//   } = {
//     name: data.name,
//     uid: data.id,
//     status: 'done' || data.status,
//     url: data.url,
//     response: '{"status": "success"}' // 服务端响应内容
//   }
//   return file
// }
const change = () => {
  const result = fileList.value?.map((item) => {
    return {
      url: item.url,
      name: item.name
    }
  })
  resultFileList.value = result
  formItemContext.onFieldChange()
}
const remove = (info: FileListTypes) => {
  fileList.value = fileList.value?.filter((i) => {
    return i.uid !== info.uid
  })
  change()
}
const isTest = (fileName: string) => {
  const reg = new RegExp(`.(${props.accept.replace(/[.\s]/g, '').replace(/,/g, '|')})$`)
  return reg.test(fileName)
}
const beforeUpload = (file: any) => {
  if (!isTest(file.name)) {
    DcMessage.warning(t('tips.templeDownForm', { fileType: props.accept }))
    return false
  }
  const isLt10M = file.size / 1024 / 1024 < 2
  if (!isLt10M) {
    DcMessage.warning(t('tips.importSize10', { fileSize: props.fileSize }))
    return false
  }
}
const exportTemple = () => {
  const eleLink = document.createElement('a')
  eleLink.download = window.API_URL + props.templateUrl
  eleLink.style.display = 'none'
  eleLink.href = window.API_URL + props.templateUrl
  document.body.appendChild(eleLink)
  eleLink.click()
  document.body.removeChild(eleLink)
}
const customRequest = (file: any) => {
  const formData = new FormData()
  formData.append('file', file.file)
  uploadFile.value = {
    uid: file.file.uid,
    name: file.file.name,
    status: 'upload'
  }
  request({
    url: props.action,
    data: formData,
    method: 'POST',
    headers: {
      'Content-type': 'multipart/form-data'
    },
    onUploadProgress({ total, loaded }) {
      progress.value = 0
      progress.value = Math.round((loaded / (total * 2)) * 100)
    }
  })
    .then((res: any) => {
      if (res && res.code === 200) {
        const { failSize, successSize, resultUrl } = res.data
        if (failSize) {
          Modal.confirm({
            title: t('tips.exportError'),
            content: t('tips.jPXmeP', {
              sussess: successSize,
              error: failSize
            }),
            okText: t('btn.download'),
            cancelText: t('btn.closure'),
            onOk() {
              const eleLink = document.createElement('a')
              eleLink.download = resultUrl
              eleLink.style.display = 'none'
              eleLink.href = resultUrl
              document.body.appendChild(eleLink)
              eleLink.click()
              document.body.removeChild(eleLink)
            }
          })
        }
        if (!failSize && successSize) {
          DcMessage.success(t('tips.importSuccess'))
        }
        // 空内容
        if (!failSize && !successSize) {
          DcMessage.error(t('tips.importEmpty'))
        }
        if (successSize) {
          emit('success')
        }
      }
    })
    .finally(() => {
      uploadFile.value = undefined
    })
}
</script>
<script lang="ts">
export default {
  name: 'uploadFile'
}
</script>

<style scoped lang="scss">
.c999 {
  color: #999;
}
.flex1 {
  flex: 1;
}
.ant-progress-inner {
  height: 30px;
}
.upload-file-list {
  height: 30px;
  padding-left: 10px;
  margin-top: 10px;
  border-radius: 4px;
  &:hover {
    .deleteIcon {
      color: #ff4c4c;
    }
  }
}
.upload-progress {
  margin-top: 10px;
  position: relative;
}
.upload-progress-percent {
  position: absolute;
  top: 50%;
  margin-top: -10px;
  margin-left: -36px;
  color: #fff;
  font-weight: 500;
}
.upload-file-list-edit {
  background: rgba(29, 76, 210, 0.1);
}
.upload-file-list-disabled {
  background: #f0f0f0;
  color: #666666;
}
.tips {
  margin-left: 8px;
  color: #aeb7d1;
  p {
    line-height: 30px;
  }
}
.upload-file-list-detail {
  color: #1d4cd2;
}
:deep .ant-progress-inner {
  border-radius: 4px;
}
:deep .ant-progress-bg {
  border-radius: 4px;
}
:deep .ant-progress-text {
  display: none;
}
:deep .ant-progress-show-info .ant-progress-outer {
  padding-right: 0;
}
</style>
